import { memo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import CandidateResultList from '../../components/CandidateResultList'
import CandidateResultItem from '../../components/CandidateResultItem'
import SaveAllToRoleButton from '../../components/helixSearch/SaveAllToRoleButton'
import {
    GenericCandidateLite,
    HelixCandidateLiteDto,
} from '../../api/role/models/CandidateDto'
import { MapExtra } from '../../utils/MapExtra'
import { PersonDto, PersonLiteDto } from '../../api/person/models/PersonDto'
import { ResolvedPersonLiteDto } from '../../api/network/models/getNetworkScopedDtos'
import { CompanyDto } from '../../api/company/models/CompanyDto'

type Props = {
    roleId: string | null
    candidates: HelixCandidateLiteDto[]
    personCache: MapExtra<string, PersonDto>
    personLiteCache: MapExtra<string, PersonLiteDto>
    resolvedPersonLites: ResolvedPersonLiteDto[]
    companyCache: MapExtra<string, CompanyDto>
    currentPageNumber: number
    perPage: number
    totalResultCount: number
    pageChanged: (pageNumber: number) => void
    perPageChanged: (perPage: number) => void
    getCandidateRank: (candidate: GenericCandidateLite) => number
    onCandidateSelection: (candidateId: string) => void
    onSaveAllCandidates: () => void
    isSavingAllCandidates: boolean
}

function CandidateList({
    roleId,
    candidates,
    personCache,
    personLiteCache,
    resolvedPersonLites,
    companyCache,
    currentPageNumber,
    perPage,
    totalResultCount,
    pageChanged,
    perPageChanged,
    getCandidateRank,
    onCandidateSelection,
    onSaveAllCandidates,
    isSavingAllCandidates,
}: Props) {
    return (
        <div className="bg-white rounded-2xl shadow-md p-6 mb-6">
            <div className="flex flex-wrap items-center justify-between gap-3 pb-2 mb-4">
                <div className="flex items-center gap-2 text-lg font-semibold text-gray-800">
                    <FontAwesomeIcon icon={faList} className="text-ctxt-blue" />
                    Candidate List
                </div>
                {roleId && (
                    <SaveAllToRoleButton
                        helixCandidateLiteDtos={candidates}
                        isSavingAllCandidates={isSavingAllCandidates}
                        onSaveAllCandidates={onSaveAllCandidates}
                    />
                )}
            </div>
            <CandidateResultList
                candidates={candidates}
                personCache={personCache}
                personLiteCache={personLiteCache}
                resolvedPersonLites={resolvedPersonLites}
                companyCache={companyCache}
                currentPageNumber={currentPageNumber}
                perPage={perPage}
                totalResultCount={totalResultCount}
                pageChanged={pageChanged}
                perPageChanged={perPageChanged}
                getCandidateRank={getCandidateRank}
                ResultItemComponent={CandidateResultItem}
                onCandidateSelection={onCandidateSelection}
                roleId={roleId || undefined}
            />
        </div>
    )
}

export default memo(CandidateList)
